import { useGetCategoriesQuery } from 'features/reimbursements/reimbursements';
import { useActiveOrganisation } from 'hooks/useActiveOrganisation';
import { useMemo } from 'react';
import { createSelector } from '@reduxjs/toolkit';

/**
 * Returns array of ids that the user has access to, undefined if not loaded yet
 */
export function useGetCategoryIds() {
    const activeOrganisation = useActiveOrganisation();

    const filterCategories = useMemo(() => {
        // Return a unique selector instance for this page so that
        // the filtered results are correctly memoized
        return createSelector(
            (res) => res.data,
            (_res, organisationId) => organisationId,
            (data, organisationId) => {
                if (!data) {
                    return undefined;
                }

                return data
                    .filter((category) => category.organisationId === organisationId)
                    .map((category) => category.id);
            },
        );
    }, []);

    const { categories } = useGetCategoriesQuery(undefined, {
        selectFromResult: (result) => ({
            categories: filterCategories(result, activeOrganisation),
        }),
    });

    return categories;
}
